import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAccessActions, useAccessData } from "../auth/AccessProvider";
import CentralDashboardShell from "../components/CentralDashboardShell";
import SystemRouterLanding from "../components/SystemRouterLanding";
import "../styles/platformAccess.css";
import "../styles/facilitatorSystems.css";

const NAV_ITEMS = [
  { id: "systems", label: "Your systems", icon: "systems" },
];

export default function SystemsDashboardPage() {
  const {
    accessContext,
    activeTenant,
    user,
  } = useAccessData();
  const { signOutUser } = useAccessActions();
  const [signOutPending, setSignOutPending] = useState(false);
  // Product return links and existing bookmarks must retain the admin workspace.
  if (activeTenant?.tenantRole === "tenant_admin") {
    return <Navigate to="/tenant-admin/dashboard" replace />;
  }
  const unityRoles = (activeTenant?.systems || []).flatMap((system) =>
    system?.key === "unityLearning" ?
      Array.isArray(system.roles) ? system.roles :
        Array.isArray(system.systemRoles) ? system.systemRoles : [system.role] : [],
  );
  const appearance = activeTenant?.tenantRole === "tenant_admin" ? "tenant-admin" :
    activeTenant?.tenantRole !== "tenant_user" ? "default" :
    unityRoles.includes("facilitator") ? "facilitator" :
      unityRoles.includes("learner") ? "learner" : "default";

  const handleSignOut = async () => {
    setSignOutPending(true);
    try {
      await signOutUser();
    } finally {
      setSignOutPending(false);
    }
  };

  return (
    <CentralDashboardShell
      user={accessContext?.user || user}
      organisation={activeTenant?.displayName}
      branding={activeTenant?.branding}
      navItems={NAV_ITEMS}
      activeSection="systems"
      onSectionChange={() => {}}
      onSignOut={handleSignOut}
      navigationDisabled={signOutPending}
      signOutPending={signOutPending}
      showAiWallet
      canAddAiWalletCredits={activeTenant?.tenantRole === "tenant_admin"}
      aiWalletTenantId={activeTenant?.tenantId}
      appearance={appearance}
    >
      <SystemRouterLanding
        user={accessContext?.user || user}
        tenant={activeTenant}
        systems={activeTenant?.systems || []}
        prominentActions={appearance !== "default"}
      />
    </CentralDashboardShell>
  );
}
